import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import HostIndividualListLayer from "../../components/HostIndividual/HostIndividualListLayer";


const HostIndividualListLayerPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Host Individual" />

        {/* UsersListLayer */}
        <HostIndividualListLayer />

      </MasterLayout>

    </>
  );
};

export default HostIndividualListLayerPage; 
